import React from "react"
import {
  ColumnDirective,
  ColumnsDirective,
  ExcelExport,
  Page,
  Filter,
  GridComponent,
  Inject,
  Sort,
  Resize,
  Toolbar,
  Edit,
  RowDD,
  DetailRow,
} from "@syncfusion/ej2-react-grids"

const SyncfusionGrid = ({
  gridRef,
  columns,
  data,
  actionComplete,
  rowSelected,
  rowDeselected,
  selectionSettings,
  onRowDrop,
  height = "100%",
  allowResizing = true,
  allowFiltering = true,
  allowSorting = true,
  allowPaging = true,
  allowSelection = true,
  allowExcelExport = true,
  allowRowDragAndDrop = false,
  pageSettings = null,
  filterSettings = null,
  editSettings = null,
  toolbar = null,
  childGrid = null,
  detailDataBound = null,
  dataBound = null,
  cellClicked = null,
}) => {
  return (
    <GridComponent
      ref={g => {
        if (gridRef != undefined && gridRef != null) gridRef.current = g
      }}
      toolbar={toolbar}
      height={height}
      width="100%"
      rowHeight={35}
      dataSource={data}
      childGrid={childGrid}
      filterSettings={
        filterSettings || {
          type: "Excel",
        }
      }
      allowRowDragAndDrop={allowRowDragAndDrop}
      allowResizing={allowResizing}
      allowFiltering={allowFiltering}
      allowSorting={allowSorting}
      allowPaging={allowPaging}
      allowSelection={allowSelection}
      rowSelected={rowSelected}
      rowDeselected={rowDeselected}
      selectionSettings={selectionSettings}
      allowExcelExport={allowExcelExport}
      actionComplete={actionComplete}
      detailDataBound={detailDataBound}
      dataBound={dataBound}
      cellClicked={cellClicked}
      pageSettings={
        pageSettings || {
          pageSizes: ["5", "10", "15", "20", "30", "50", "All"],
          pageSize: 30,
        }
      }
      editSettings={editSettings}
      rowDrop={onRowDrop}
    >
      <ColumnsDirective>
        {/* <ColumnDirective type="checkbox" width="50" freeze="Left" /> */}
        {columns && columns.map((col, idx) => (
          <ColumnDirective key={idx} {...col} />
        ))}
      </ColumnsDirective>
      <Inject
        services={[Filter, Page, Sort, ExcelExport, Resize, Edit, Toolbar, RowDD, DetailRow]}
      />
    </GridComponent>
  )
}

export default SyncfusionGrid
